var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6555 2.35965C20.5423 2.30067 20.3605 2.25119 20.1394 2.2607C19.6254 2.68349 19.7221 5.04884 19.8711 6.447C19.6471 8.03523 21.197 9.40547 22 9.89206C19.9832 11.527 20.2633 15.3613 20.6555 17.0741C19.1317 16.5603 16.8086 18.5728 15.8375 19.6433C13.4174 20.9513 11.4678 20.9279 10.7955 20.7528C9.06605 19.6976 6.93627 19.3528 5.92884 19.2996C7.42959 22.3633 6.45601 20.6072 5.7535 19.293C5.80732 19.2941 5.86589 19.2963 5.92884 19.2996C5.87377 19.1872 5.81537 19.0683 5.7535 18.9426C4.0056 15.3925 2.74697 13.96 2.33613 13.6875C3.36695 9.7636 2.54155 7.61482 2 7.03091C6.7372 6.68529 6.46724 2.79085 6.30479 1.98476C6.27683 1.95745 6.26069 1.92679 6.2577 1.89251C6.24905 1.79334 6.27513 1.83756 6.30479 1.98476C6.69598 2.36673 9.40125 2.09233 10.7955 1.89251C12.2745 1.5188 10.7395 1.30861 9.78712 1.25023C15.6583 0.362688 17.014 2.04824 16.958 3.00195C17.8095 3.51579 18.5826 3.21605 18.8627 3.00195C19.3082 2.4506 19.7767 2.27631 20.1394 2.2607C20.2694 2.15379 20.4384 2.17109 20.6555 2.35965Z",
    fill: "#F94F01",
    stroke: "#F94F01"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.333aadd6.svg";
export { ForwardRef as ReactComponent };